import { featuresData, aboutData } from '@/mocks/homeData';

export default function FeaturesAboutSection() {
  return (
    <>
      <section id="features" className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">为什么选我们</h2>
            <p className="mt-2 text-sm text-foreground-500">七年深耕，只为给你最好的吃瓜体验</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {featuresData.map((feature, idx) => (
              <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 text-center group hover:-translate-y-1 transition-all duration-300">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-600 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900">{feature.title}</h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="about" className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于吃瓜网51</h2>
            <p className="mt-2 text-sm text-foreground-500">国内领先的娱乐八卦与黑料爆料平台</p>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-10">
            <div className="space-y-4">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{aboutData.content1}</p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{aboutData.content2}</p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{aboutData.content3}</p>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50">
                  <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}